import { Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalContent, StyledTextArea } from './SolveReportAndSendMessageModal.styles';

const { Text, Paragraph } = Typography;

interface Props {
  open: boolean;
  userName: string;
  activityName: string;
  onConfirm: (message: string) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const SolveReportAndSendMessageModal: React.FC<Props> = ({
  open,
  userName,
  activityName,
  onConfirm,
  onCancel,
  isLoading
}) => {
  const [modal, contextHolder] = Modal.useModal();
  const { t } = useTranslation('ProblemReportsTranslations');

  const defaultMessage = t('RESOLVE_MODAL_DEFAULT_MESSAGE', { activityName });
  const [message, setMessage] = useState(defaultMessage);

  useEffect(() => {
    if (open) {
      setMessage(defaultMessage);
    }
  }, [open, defaultMessage]);

  const handleConfirm = () => {
    onConfirm(message);
  };

  const handleCancel = () => {
    modal.confirm({
      title: t('RESOLVE_MODAL_CANCEL_TITLE'),
      content: t('RESOLVE_MODAL_CANCEL_CONTENT'),
      okText: t('RESOLVE_MODAL_CANCEL_STAY'),
      cancelText: t('RESOLVE_MODAL_CANCEL_LEAVE'),
      onCancel
    });
  };

  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title={t('RESOLVE_MODAL_TITLE')}
        okText={t('RESOLVE_MODAL_CONFIRM_BUTTON')}
        onOk={handleConfirm}
        onCancel={handleCancel}
        confirmLoading={isLoading}
        width={700}
        maskClosable={false}
        cancelButtonProps={{ style: { display: 'none' } }}>
        <ModalContent>
          <Paragraph>{t('RESOLVE_MODAL_DESCRIPTION')}</Paragraph>

          <Text strong>{t('RESOLVE_MODAL_SEND_TO', { userName })}</Text>

          <StyledTextArea
            value={message}
            onChange={e => setMessage(e.target.value)}
            autoSize={{ minRows: 8, maxRows: 12 }}
          />

          <Text type="secondary">{t('RESOLVE_MODAL_EDITABLE_HINT')}</Text>
        </ModalContent>
      </Modal>
    </>
  );
};
